(function() {

	var Texture = include("PIXI.Texture"),
		Application = include("springroll.Application"),
		Sprite = include("PIXI.Sprite"),
		Container = include("PIXI.Container"),
		AdvancedMovieClip = include("springroll.pixi.AdvancedMovieClip"),
		Tween = include("createjs.Tween"),
		GeomUtils = include("heist.GeomUtils"),
		Polygon = include("heist.Polygon"),
		CollisionUtils = include("heist.CollisionUtils"),
		Line = include("heist.Line");

	var Elmo = function(state)
	{
		this.state = state;
		
		var app = this.app = Application.instance;
		var config = app.config.game.stealth.elmoData;

		Container.call(this);
		
		this.anim = new AdvancedMovieClip(app.getCache("ElmoData"), app.getCache("ElmoAtlas"));
		this.addChild(this.anim);

		this.moveSpeed = config.speed;
		this.animSpeed = config.animSpeed;
		if(config.scale)
			this.scale.x = this.scale.y = config.scale;

		this.collision = new Polygon(config.collision);
		
		this.triggerWalk = this.triggerWalk.bind(this);
		this.onWalkDone = this.onWalkDone.bind(this);
		this.update = this.update.bind(this);
		
		this.type = "elmo";
	};

	var helperLine = new Line(0, 0, 0, 0);

	// Extend MovieClip
	var s = Container.prototype;
	var p = Elmo.prototype = Object.create(s);
	
	Object.defineProperty(p, "worldPos", {
		get: function() { return this.position.y; }
	});

	Object.defineProperty(p, "enabled", {
		get: function() { return this._enabled; },
		set: function(value)
		{
			this._enabled = value;
			this.interactive = value;
			this.buttonMode = value;
			
			this.off("mousedown", this.triggerWalk);
			this.off("touchstart", this.triggerWalk);
			if(value)
			{
				this.on("mousedown", this.triggerWalk);
				this.on("touchstart", this.triggerWalk);
			}
		}
	});

	p.triggerWalk = function()
	{
		this.state.startElmoWalk();
		this.state.elmoClicks++;
	};

	p.walkTo = function(x, y)
	{
		var position = this.position;
		//get the time and convert it to milliseconds
		var time = GeomUtils.distance(position, x, y) / this.moveSpeed * 1000;
		Tween.get(this.position).to({x: x, y: y}, time).call(this.onWalkDone);
		this.collision.setOrigin(position.x, position.y);
		this.app.on("update", this.update);
		//figure out the direction based on largest cardinal direction of movement
		var anim;
		if(Math.abs(x - position.x) > Math.abs(y - position.y))
		{
			if(x - position.x < 0)
				anim = "walkL";
			else
				anim = "walkR";
		}
		else
		{
			if(y - position.y < 0)
				anim = "walkU";
			else
				anim = "walkD";
		}
		this.app.animator.play(this.anim, {anim:anim, speed:this.moveSpeed / this.animSpeed});
	};

	p.update = function(elapsed)
	{
		//update collision polygon
		var collision = this.collision;
		collision.setOrigin(this.position.x, this.position.y);
		
		//check for collisions with guards or flashlights
		var guards = this.state.guards;
		for(var i = 0; i < guards.length; ++i)
		{
			var guard = guards[i];
			//if the guard isn't on the stage, then it is a spare
			//from a previous level
			if(!guard.parent) break;
			if(CollisionUtils.checkPolygonCollision(collision, guard.viewCollision))
			{
				//make sure there isn't a wall in the way
				helperLine.setTo(this.position.x, this.position.y,
								guard.position.x + guard._light.position.x,
								guard.position.y + guard._light.position.y);
				var walls = this.state.walls;
				var foundWall = false;
				//when found, ensure a wall isn't in the way
				for(var j = 0; j < walls.length; ++j)
				{
					var wallArea = walls[j].wallArea;
					if(wallArea)
					{
						for(var k = 0; k < wallArea.length; ++k)
						{
							if(CollisionUtils.checkLinePolygonCollision(helperLine, wallArea[k]))
							{
								foundWall = true;
								break;
							}
						}
						if(foundWall)
							break;
					}
				}
				if(!foundWall)
				{
					//do state things, like pausing all guards momentarily
					this.state.catchElmo();
					//play the guard's longer 'bawk' animation and SFX
					guard.playCatch();
					//stop Elmo
					this.getCaught();
					break;
				}
			}
			else if(CollisionUtils.checkPolygonCollision(collision, guard.bodyCollision))
			{
				//if you hit a guard, they see you
				this.state.catchElmo();
				guard.playCatch();
				this.getCaught();
				break;
			}
		}
	};

	p.onWalkDone = function()
	{
		this.app.off("update", this.update);
		this.playIdle();
		this.state.nextTile();
	};

	p.getCaught = function()
	{
		this.app.off("update", this.update);
		Tween.removeTweens(this.position);
		this.playIdle();
	};
	
	p.playIdle = function()
	{
		this.app.animator.play(this.anim, "idle");
	};
	
	p.playWin = function()
	{
		this.app.animator.play(this.anim, "win");
	};

	p.destroy = function()
	{
		this.app.off("update", this.update);
		this.app.animator.stop(this.anim);
		Tween.removeTweens(this.position);
		this.anim.destroy();
		this.triggerWalk = this.anim = this.state = this.collision = this.onWalkDone =
			this.update = this.app = null;
	};

	namespace('heist').Elmo = Elmo;
}());